import { render } from "./webServiceData.vue?vue&type=template&id=1d9970d0&lang=pug"
import script from "./webServiceData.vue?vue&type=script&lang=js"
export * from "./webServiceData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/webServiceData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d9970d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d9970d0', __exports__)) {
    api.reload('1d9970d0', __exports__)
  }
  
  module.hot.accept("./webServiceData.vue?vue&type=template&id=1d9970d0&lang=pug", () => {
    api.rerender('1d9970d0', render)
  })

}


export default __exports__